<template>
  <button :type="type" :class="[
      props.size === 'sm' && 'tw-h-[30px]',
      props.size === 'md' && 'tw-h-[40px]',
      props.size === 'lg' && 'tw-h-[50px]',
      props.size === 'sm' ? 'tw-text-tiny tw-px-3 tw-py-1' : 'tw-font-bold tw-px-4 tw-py-2',
      ' tw-rounded-[8px]',
      clases,
    border && 'tw-border',
    disabled && 'tw-opacity-35',
    props.variant === 'outline' ?
      (props.color === 'primary' ? 'tw-border-primary-500 tw-text-primary-500 tw-bg-white hover:tw-bg-primary-50' :
        props.color === 'secondary' ? 'tw-border-secondary-500 tw-text-secondary-500 tw-bg-white hover:tw-bg-secondary-50' :
        props.color === 'success' ? 'tw-border-success-500 tw-text-success-500 tw-bg-white hover:tw-bg-success-50' :
        props.color === 'danger' ? '!tw-border-red-300 tw-text-red-500 tw-bg-white hover:tw-bg-red-50' :
        props.color === 'warning' ? 'tw-border-warning-500 tw-text-warning-500 tw-bg-white hover:tw-bg-warning-50' :
        props.color === 'info' ? 'tw-border-info-500 tw-text-info-500 tw-bg-white hover:tw-bg-info-50' :
        props.color === 'light' ? 'tw-border-gray-300 tw-text-gray-700 tw-bg-white hover:tw-bg-gray-100' :
        props.color === 'blue-dark' ? 'tw-border-blue-dark-500 tw-text-blue-dark-500 tw-bg-white hover:tw-bg-blue-dark-50' : ''
      ) : (
      props.color === 'primary' ? 'tw-bg-primary-500 tw-text-white hover:tw-bg-primary-600' :
        props.color === 'secondary' ? 'tw-bg-secondary-500 tw-text-white hover:tw-bg-secondary-600' :
        props.color === 'success' ? 'tw-bg-success-500 tw-text-white hover:tw-bg-success-600' :
        props.color === 'danger' ? 'tw-bg-red-500 tw-text-white hover:tw-bg-red-600' :
        props.color === 'warning' ? 'tw-bg-warning-500 tw-text-white hover:tw-bg-warning-600' :
        props.color === 'info' ? 'tw-bg-info-500 tw-text-white hover:tw-bg-info-600' :
        props.color === 'light' ? 'tw-bg-gray-100 tw-text-gray-700 hover:tw-bg-gray-200' :
        props.color === 'blue-dark' ? 'tw-bg-blue-dark-500 tw-text-white hover:tw-bg-blue-dark-600' : ''
      ),
    ]"
          :disabled="disabled || loading">
    <slot></slot>
    {{ label }}
    <loading-spinner :show="loading" size="sm" class="ms-2 tw-align-middle" :class="loading_class" />
  </button>
</template>

<script setup>

import {computed} from "vue";

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: 'primary',
    validator(value) {
      return ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'blue-dark'].includes(value);
    }
  },
  size: {
    type: String,
    default: 'md',
    validator(value) {
      return ['sm', 'md', 'lg'].includes(value);
    }
  },
  variant: {
    type: String,
    default: 'outline',
    validator(value) {
      return ['outline', 'fill'].includes(value);
    }
  },
  class: {
    type: String,
    default: '',
  },
  loading_class: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'button',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  border: {
    type: Boolean,
    default: true
  }
})


const clases = computed(() => {
  return props.class
})

</script>
